import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import App from './app/App';
import './index.css';
import Clarity from '@microsoft/clarity';
import { initSentry } from './lib/sentry';

// Initialize Sentry
initSentry();

// Initialize Clarity
Clarity.init(import.meta.env.VITE_CLARITY_ID as string);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
